import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { memo, useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setAuthInfo as setAuth } from '../../../store/modules/auth';
import BackgroundContainer from '../../shared/backgroundContainer';
import { useTranslations } from '../../../utility/useTranslations';
import { getSubdomain } from '../../../utility/uiUtils';
import { getOrganizationSettings as getGlobalSettings } from '../../../store/modules/organizationSettings';
import { APP_PAGES } from '../../../constants/pages';
import DisableAuthenticationForm from '../../shared/disableAuthenticationForm';

const DisableAuthenticationPage = ({ auth, organizationSettings }) => {
  const navigate = useNavigate();
  const translations = useTranslations(APP_PAGES.DISABLE_AUTHENTICATION_PAGE);
  const subDomain = getSubdomain(window.location.hostname);
  const dispatch = useDispatch();

  const is2FARequired =
    organizationSettings?.is_2fa_required && !!auth?.has_2fa_enabled;

  const setAuthInfo = useCallback(data => dispatch(setAuth(data)), [dispatch]);

  useEffect(() => {
    getGlobalSettings(dispatch);
  }, [dispatch]);

  return (
    <BackgroundContainer
      translations={translations.authContainer}
      removeTopButton
      subDomain={subDomain}
    >
      <DisableAuthenticationForm
        translations={translations}
        auth={auth}
        navigate={navigate}
        organizationSettings={organizationSettings}
        setAuthInfo={setAuthInfo}
        isResetAuthenticationView={is2FARequired}
      />
    </BackgroundContainer>
  );
};

DisableAuthenticationPage.propTypes = {
  auth: PropTypes.object.isRequired,
  organizationSettings: PropTypes.object.isRequired,
};

export default memo(DisableAuthenticationPage);
